import myAxios from '@/utils';
import { id } from 'postcss-selector-parser';

/**
 * 获取课程列表
 */
type coursewareListResult = {
  fileName: String; //文件名称
  courseName: String; //课程名称
  isBind: String; //true = 绑定  false=未绑定
  type: Number; //1 = 视频 2=材料 3=字幕
  pageNum: Number; //当前页
  pageSize: Number; //每页条数
};
/**
 * 删除题件
 */
type deleteResult = {
  id: String; //题目ID
};
/**
 * 绑定字幕
 */
type bindSubtitlesResult = {
  videoId: String;
  subtitleId: String;
};
/**
 * 设置时长
 */
type dataTimeForm = {
  id: String;
  fileTime: String;
};
/**
 * 文件上传
 */
type uploadForm = {
  fileInfos: Array<String>;
};
/**
 * 课件库详情
 */
type details = {
  id: String;
};
const CoursewareServer = {
  // 获取课件库列表
  getCoursewareList: (params: object) => {
    return (myAxios as any)(
      Object.assign(
        {
          url: '/operate-service/operate/courseware/pageList',
          method: 'get',
        },
        { data: params },
      ),
    );
  },
  // 删除
  deleteCourseware: (params: deleteResult) => {
    return (myAxios as any)(
      Object.assign(
        {
          url: '/operate-service/operate/courseware/del',
          method: 'delete',
        },
        { data: params },
      ),
    );
  },
  // 批量删除
  deleteMultipleCourseware: (params: object) => {
    return (myAxios as any)(
      Object.assign(
        {
          url: '/operate-service/operate/courseware/batchDel',
          method: 'post',
        },
        { data: params },
      ),
    );
  },
  //绑定字幕
  bindSubtitles: (params: bindSubtitlesResult) => {
    return (myAxios as any)(
      Object.assign(
        {
          url: '/operate-service/operate/courseware/bindSubtitle',
          method: 'post',
        },
        { data: params },
      ),
    );
  },
  // 移除视频字幕
  removeSubtitles: (videoId: string) => {
    return (myAxios as any)(
      Object.assign({
        url: `/operate-service/operate/courseware/removeSubtitle/${videoId}`,
        method: 'post',
      }),
    );
  },
  //设置时长
  setReadingTime: (params: dataTimeForm) => {
    return (myAxios as any)(
      Object.assign(
        {
          url: '/operate-service/operate/courseware/setReadingTime',
          method: 'post',
        },
        { data: params },
      ),
    );
  },
  //设置时长
  upload: (params: uploadForm) => {
    return (myAxios as any)(
      Object.assign(
        {
          url: '/operate-service/operate/courseware/save',
          method: 'post',
        },
        { data: params },
      ),
    );
  },
  //课件库详情
  getDetails: (params: details) => {
    return (myAxios as any)(
      Object.assign(
        {
          url: '/operate-service/operate/courseware/getInfoById/' + params,
          method: 'get',
        },
        {},
      ),
    );
  },

  // 导入外部链接课件
  importLinks: (params: object) => {
    return (myAxios as any)(
      Object.assign(
        {
          url: 'operate-service/operate/courseware/importCourseware',
          method: 'post',
        },
        { data: params },
      ),
      'multipart/form-data'
    );
  },

  //   修改外部文件链接
  changeLink: (params: object) => {
    return (myAxios as any)(
      Object.assign(
        {
          url: 'operate-service/operate/courseware/updateUrl',
          method: 'post',
        },
        { data: params },
      ),
    );
  },

  // 紫光云获取token
  getToken: () => {
    return (myAxios as any)(
      Object.assign(
        {
        url: '/community-service/community/file/getCredentialsToken',
        method: 'get',
      }),
    );
  },
};

export { CoursewareServer };
